import { postRequest } from '../../../../../../middlewares/api/actions';
import { getTempTablePreviewUrl, getDeleteCalcFieldUrl, getTablePreviewDownload } from '../../../../../../constants/urls';
import moment from 'moment';
import _ from 'lodash';

export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PREVIEW_GET = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PREVIEW_GET';
export const FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_HIDE = 'FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_HIDE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_SHOW = 'FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_SHOW';
export const FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_DOWNLOAD = 'FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_DOWNLOAD';

export const getFileMappingWizardPreviewRowListCsvRows = (pageNum, pageSize, filterTable, sortCols, sortByDesc, functionQuery, aliasQuery, tableName, fixed, checkedHeader, isEdit) => 
{
  var editCheckedHeader = _.clone(checkedHeader);
  if(!isEdit) {
    editCheckedHeader.push(aliasQuery.toUpperCase());
  }
  return ({
    ...postRequest(
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PREVIEW_GET,
  getTempTablePreviewUrl(tableName),
  {
    PageNum: pageNum,
    PageSize: pageSize,
    FilterTable: filterTable,
    SortCols: sortCols,
    SortByDesc: sortByDesc,
        SelCols: editCheckedHeader ? editCheckedHeader.map(item => `[${item.toUpperCase()}]`) : null,
    HasCalculatedField: true,
        CalculatedFieldName: isEdit ? `${aliasQuery.toUpperCase()}_XEDITX_` : aliasQuery.toUpperCase(),
    CalculatedFieldExpression: fixed ? `'${functionQuery.replace(/'/g, "''")}'` : functionQuery
  }
    )
  })
}


export const showFileMappingWizardPreviewRowList = (fixed) => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_SHOW,
  fixed: fixed
});

export const hideFileMappingWizardPreviewRowList = (tableName, aliasQuery, isEdit) => postRequest(
  FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_ROW_LIST_HIDE,
  getDeleteCalcFieldUrl(tableName),
  {
    PageNum: 0,
    PageSize: 0,
    FilterTable: [],
    SortCols: [],
    SortByDesc: false,
    SelCols: null,
    HasCalculatedField: true,
    CalculatedFieldName: isEdit ? `${aliasQuery.toUpperCase()}_XEDITX_` : aliasQuery.toUpperCase(),
    CalculatedFieldExpression: null
  }
);

export const downloadTablePreview = (tableName, separator, delimiter, functionQuery, aliasQuery, checkedHeaders, compression, isEdit) => 
{
  const currDate = moment().format('YYYY-MM-DD_HH-mm-ss');
  const fileSave = {
    name: `${tableName}_${aliasQuery.toUpperCase() != "" ? `preview_${aliasQuery.toUpperCase()}` : 'DATASET'}_${currDate}.${compression ? 'zip' : 'csv'}`,
    type: "text/plain;charset=utf-8"
  };
  var editCheckedHeader = _.clone(checkedHeaders);
  if(!isEdit && aliasQuery.length > 0) {
    editCheckedHeader.push(aliasQuery.toUpperCase());
  }
  return ({
    ...postRequest(
      FILE_MAPPING_WIZARD_ADD_FIELD_PREVIEW_DOWNLOAD,
      getTablePreviewDownload(tableName, separator, delimiter, !!compression),
      {
        PageNum: 1,
        PageSize: -1,
        FilterTable: [],
        SortCols: [],
        SortByDesc: false,
        SelCols: editCheckedHeader ? editCheckedHeader.map(item => `[${item}]`) : null,
        HasCalculatedField: true,
        CalculatedFieldName: aliasQuery.toUpperCase(),
        CalculatedFieldExpression: functionQuery
      },
      undefined,
      undefined,
      true
      ),
    fileSave
  })
};
  